var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagramColor = function SvgInstagramColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram-color_svg__a",
    x1: -0.06,
    x2: 0.92,
    y1: 1.08,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#ff543e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c837ab"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5216"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#instagram-color_svg__a)",
    d: "M1.626 1.767C-.411 3.882.006 6.13.006 12.958c0 5.67-.989 11.354 4.189 12.692 1.617.416 15.945.416 17.56 0a5.568 5.568 0 0 0 4.15-5.354c.033-.426.033-14.24 0-14.674a5.576 5.576 0 0 0-4.889-5.5A23.327 23.327 0 0 0 17.192 0C6.2.008 3.794-.481 1.626 1.767",
    "data-name": "Path 20696",
    transform: "translate(.07 .038)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.033 3.178c-4.026 0-7.85-.358-9.31 3.389-.6 1.548-.516 3.557-.516 6.435 0 2.525-.081 4.9.516 6.434 1.457 3.749 5.312 3.39 9.308 3.39 3.856 0 7.831.4 9.309-3.39.6-1.563.516-3.543.516-6.434 0-3.838.212-6.315-1.65-8.176-1.885-1.888-4.436-1.648-8.177-1.648Zm-.88 1.77c8.4-.013 9.468-.947 8.878 12.02-.21 4.586-3.7 4.083-8 4.083-7.829 0-8.054-.224-8.054-8.054 0-7.921.621-8.045 7.172-8.051Zm6.126 1.631a1.178 1.178 0 1 0 1.179 1.178 1.179 1.179 0 0 0-1.179-1.178m-5.246 1.378a5.044 5.044 0 1 0 5.044 5.045 5.046 5.046 0 0 0-5.044-5.045m0 1.77c4.33 0 4.336 6.549 0 6.549s-4.335-6.549 0-6.549",
    "data-name": "Path 20697"
  }))));
};
export default SvgInstagramColor;